/* tslint:disable */

declare var Object: any;
export interface NewsInterfaceInterface {
  "id"?: any;
}

export class NewsInterface implements NewsInterfaceInterface {
  "id": any;
  constructor(data?: NewsInterfaceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `NewsInterface`.
   */
  public static getModelName() {
    return "NewsInterface";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of NewsInterface for dynamic purposes.
  **/
  public static factory(data: NewsInterfaceInterface): NewsInterface{
    return new NewsInterface(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'NewsInterface',
      plural: 'NewsInterface',
      path: 'NewsInterface',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
